import { Container, Card } from "react-bootstrap"
import { motion } from 'framer-motion'
import { FormattedMessage } from 'react-intl'

import '../../css/App.css'
import '../../css/content/Jobs.css'

function Jobs() {
    return (
        <motion.div
            initial={{opacity: 0}} 
            animate={{opacity: 1}} 
            exit={{opacity: 0}}>
            <Container>
                <h1 className='contentHeadline'><FormattedMessage id="jobs.headline" /></h1>
                <Card style={{ width: '100%', border: '0'}}>
                    <Card.Body>
                        <Card.Subtitle className='contentSubheadline'><FormattedMessage id="jobs.subheadline" values={{h4: (heading4) => <h4>{heading4}</h4>}}/></Card.Subtitle>
                        <Card.Text><FormattedMessage id="jobs.description" values={{p: (...chunks) => <p>{chunks}</p>}}/></Card.Text>
                    </Card.Body>
                </Card>
                {/*<Card style={{ width: '100%', border: '0'}}>
                    <Card.Body>
                        <Card.Subtitle className='contentSubheadline'><FormattedMessage id="jobs.subheadline" values={{h4: (heading4) => <h4>{heading4}</h4>}}/></Card.Subtitle>
                        <Card.Text><FormattedMessage id="jobs.description" values={{p: (...chunks) => <p>{chunks}</p>, br: <br />, h5: (...heading) => <h5>{heading}</h5>, h4: (heading4) => <h4>{heading4}</h4>, studentAssistant: <a href="https://www.imi-frankfurt.de/wp-content/uploads/2024/01/2024_01_29_A_Hiwi_ProSkive.pdf" target="_blank" rel="noreferrer">Student assistant (m/f/d)</a>, studentischeHilfskraft: <a href="https://www.imi-frankfurt.de/wp-content/uploads/2024/01/2024_01_29_A_Hiwi_ProSkive.pdf" target="_blank" rel="noreferrer">Studentische Hilfskraft (m/w/d)</a>, jobAnnouncement: <a href="https://www.imi-frankfurt.de/wp-content/uploads/2024/01/2024_01_29_A_Hiwi_ProSkive.pdf" target="_blank" rel="noreferrer">job announcement</a>, stellenausschreibung: <a href="https://www.imi-frankfurt.de/wp-content/uploads/2024/01/2024_01_29_A_Hiwi_ProSkive.pdf" target="_blank" rel="noreferrer">Stellenausschreibung</a> }}/></Card.Text>
                    </Card.Body>
                </Card>*/}
                <Card style={{ width: '100%', border: '0'}}>
                    <Card.Body>
                        <Card.Subtitle className='contentSubheadline'><FormattedMessage id="jobs.alsoSubheadline" values={{h4: (heading4) => <h4>{heading4}</h4>}}/></Card.Subtitle>
                        <Card.Text><FormattedMessage id="jobs.alsoDescription" values={{p: (...chunks) => <p>{chunks}</p>, br: <br />, h5: (...heading) => <h5>{heading}</h5>, h4: (heading4) => <h4>{heading4}</h4> }}/></Card.Text>
                    </Card.Body>
                </Card>
            </Container>
        </motion.div>
    )
  }
  
  export default Jobs